import DraftReportsCarousel from './DraftReportsCarousel';

export default DraftReportsCarousel;
